


























import { plainToInstance } from 'class-transformer'
import { cloneDeep } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop, VModel } from 'vue-property-decorator'

import SwitchInput from '../../../../../../../../../Pi/fields/SwitchInput/SwitchInput.vue'
import BaseCondition from '../../../logic/ConditionTypes/BaseCondition'
import BetweenPropertyCondition from '../../../logic/ConditionTypes/BetweenPropertyCondition'
import HasLabelConditions
  from '../../../logic/ConditionTypes/LabelConditions/HasLabelConditions'
import LabelCondition from '../../../logic/ConditionTypes/LabelConditions/LabelCondition'
import PropertyCondition from '../../../logic/ConditionTypes/PropertyCondition'
import SetPropertyCondition from '../../../logic/ConditionTypes/SetPropertyConditions/SetPropertyCondition'
import PropertyValue from '../../../logic/PropertyConditionValues/PropertyValue'
import { ConditionsNodeProps, ConditionType } from '../../../logic/types'
import ConditionParamCell from './ConditionParamsCell/ConditionParamCell.vue'
import UserPropertiesCell from './UserPropertiesCell/UserPropertiesCell.vue'
import { SelectedPropertyType } from './types'

@Component({
  components: {
    SwitchInput,
    UserPropertiesCell,
    ConditionParamCell
  },
})
export default class ConditionEditor extends Vue {
  @VModel() condition!: BaseCondition | null

  @Prop() nodeProps!: ConditionsNodeProps

  prevConditionType: SelectedPropertyType | null = null

  selectedProperty: number | null = null

  get conditionPropId(): number | null  {
    if (this.condition && this.condition instanceof LabelCondition) {
      return this.condition.label_index
    }

    if (this.selectedProperty) {
      return this.selectedProperty
    }

    return null
  }

  selectProperty({ type, id }: { type: SelectedPropertyType, id: number }): void {
    this.prevConditionType = type

    if (type === SelectedPropertyType.Label) {
      if (this.condition instanceof LabelCondition) {
        this.condition.label_index = id
      } else {
          this.condition = plainToInstance(HasLabelConditions, {
            type: ConditionType.HasLabel,
            label_index: id,
          })
      }
    }

    if (type === SelectedPropertyType.Property) {
      this.selectedProperty = id
      this.condition = null
    }
  }

  @Emit()
  addCondition(): this {
    this.$nextTick(() => {
      this.condition = null
      this.prevConditionType = null
      this.selectedProperty = null
    })

    return this
  }

  created(): void {
    if (this.condition) {
      if ((this.condition instanceof PropertyCondition || this.condition instanceof BetweenPropertyCondition) && this.condition.left instanceof PropertyValue) {
        this.prevConditionType = SelectedPropertyType.Property
        this.selectedProperty = this.condition.left.property_index
      }

      if (this.condition instanceof SetPropertyCondition) {
        this.prevConditionType = SelectedPropertyType.Property
        this.selectedProperty = this.condition.property_index
      }

      if (this.condition instanceof LabelCondition) {
        this.prevConditionType = SelectedPropertyType.Label
        this.selectedProperty = this.condition.label_index
      }
    }
  }
}
